import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CpProvinciaResult } from '../models/cp-provincia-result';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  // private productoId=environment.productoId;
  public url: string = environment.baseUrl;
  headers = new HttpHeaders().set('Content-Type','application/json');

  apiUsuario(cookie: string): Observable<any>{
    let dato = '{"strId":"'+ cookie +'"}';     
    return this.http.post<any>(this.url + '/api/usuario', dato, {headers: this.headers});
  }

  token(mistrUsuario: string, mistrPassword: string): Observable<any>{
    var data = "username=" + mistrUsuario + "&password=" + mistrPassword + "&grant_type=password";
    return this.http.post<any>(this.url + '/token' , data, { headers: this.headers });
  } 

  apiSesion(strUsuario: string, strPassword: string, intRolTipo: number, miCookie: string): Observable<any>{
    let dato = '{"strUsuario": "'+ strUsuario +'", "strContrasena":"'+ strPassword + '", "intRolTipo":' + intRolTipo +', "strCookie":"'+ miCookie +'"}';
    return this.http.post<any>(this.url + '/api/sesion/autenticacion', dato, {headers: this.headers});
  }

  /********** Obtener LOGO *************/

  getLogo(cookie):Observable<any>{
    let urlCompleta=this.url+'/api/producto?strCookie='+cookie;
 
    return this.http.get<any>(urlCompleta,{headers:this.headers});
  }

  getDatosGeneralesEst(cookie):Observable<any>{
    let urlCompleta=this.url+'/api/establecimiento/general?strCookie='+cookie;
 
    return this.http.get<any>(urlCompleta,{headers:this.headers});
  }

  /********** REGISTRO *************/

  apiRegistro(Email: string, Password: string, cookie, strUrl): Observable<any>{
    let dato = '{"strEmail": "'+ Email +'", "strPassword":"'+ Password + '", "strUserName":"'+ Email +'"}';
    return this.http.post<any>(this.url + '/api/cliente/pedidoonline/agregar?strCookie='+cookie+"&strUrl="+strUrl, dato, {headers: this.headers});
  } 

  //Obtener los datos del cliente
  apiRecuperaRegistro(cookie, strCookieGestion): Observable<any>{
    // var jsonString = JSON.stringify(cliente);
    return this.http.post<any>(this.url + '/api/cliente/pedidoonline/recupera/preregistro?strCookie='+cookie+"&strCookieGestion="+strCookieGestion, null, {headers: this.headers});
  } 

  //Confirma registro
  apiConfirmaRegistro(cookie, cliente): Observable<any>{
    var jsonString = JSON.stringify(cliente);
    return this.http.post<any>(this.url + '/api/cliente/pedidoonline/confirma/registro?strCookie='+cookie, jsonString, {headers: this.headers});
  }

  //CAROL 27/08/21
  //Recupera las provincias
  getProvincias(cookie:string,intCod:number,strParametroLike:string):Observable<CpProvinciaResult>{
    let urlCompleta=this.url+'/api/cp_provincia/pedidoonline/getProvincia?strCookie='+cookie+'&intCod='+intCod+'&strParametroLike='+strParametroLike;
 
    return this.http.get<CpProvinciaResult>(urlCompleta,{headers:this.headers});
  }

}
